import { DbRef } from '@caresend/types';
import update from 'immutability-helper';
import '@caresend/utils';
import 'firebase/auth';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/firebaseConfig/init.js';
import { dbUpdate, getValueOnce } from '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import { toastError } from '../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { initExtendedModule } from '../helpers.js';

const initialInsuranceStateData = () => ({
    isInsuranceProviderModalOpen: false,
});
const insuranceState = {
    data: initialInsuranceStateData(),
    draftInsuranceProviders: {},
    insuranceProviders: {},
};
const insuranceMutations = {
    'insurance/RESET_MODULE': (state) => {
        state.data = initialInsuranceStateData();
        state.draftInsuranceProviders = {};
        state.insuranceProviders = {};
    },
    'insurance/SET_DRAFT_INSURANCE_PROVIDER': (state, insuranceProvider) => {
        state.draftInsuranceProviders = update(state.draftInsuranceProviders, {
            [insuranceProvider.id]: { $set: insuranceProvider },
        });
    },
    'insurance/SET_INSURANCE_PROVIDERS': (state, insuranceProviders) => {
        state.insuranceProviders = insuranceProviders;
    },
};
const insuranceActions = {
    'insurance/createDraftInsuranceProviders': async ({ commit, state }) => {
        const draftInsuranceProviders = Object.values(state.draftInsuranceProviders);
        if (!draftInsuranceProviders.length)
            return;
        try {
            await dbUpdate(DbRef.INSURANCE_PROVIDERS, state.draftInsuranceProviders);
            commit('insurance/RESET_MODULE');
        }
        catch (e) {
            toastError('Failed to save insurance providers');
        }
    },
    'insurance/fetchInsuranceProviders': async ({ commit }) => {
        const insuranceProviders = await getValueOnce(DbRef.INSURANCE_PROVIDERS);
        if (!insuranceProviders)
            return;
        commit('insurance/SET_INSURANCE_PROVIDERS', insuranceProviders);
    },
};
const insuranceGetters = {
    'insurance/getInsuranceProviderOptions': (state) => Object.values({
        ...state.draftInsuranceProviders,
        ...state.insuranceProviders,
    }).map(({ id, name }) => ({
        id,
        label: name,
    })),
};
const insuranceModule = {
    actions: insuranceActions,
    getters: insuranceGetters,
    mutations: insuranceMutations,
    state: insuranceState,
};
const initInsuranceModule = (moduleExtensions) => initExtendedModule(insuranceModule, moduleExtensions);

export { initInsuranceModule, insuranceModule };
